import React from "react";
import { UNION_CITY_LICENSES } from "@bto/shared";
import { GetTypographyContent } from "../shared/Typography/Typography";

export const FooterAccreditationInfoTop = (): React.ReactElement => (
  <>
    {GetTypographyContent({
      content: "ACCREDITATIONS UNION CITY:",
      size: "small",
    })}
    {UNION_CITY_LICENSES.map((license, index) => (
      <React.Fragment key={license.content}>
        {index > 0 &&
          GetTypographyContent({
            content: "•",
            size: "small",
          })}
        {license.link
          ? GetTypographyContent({
              content: license.content,
              size: "small",
              link: license.link,
              externalLink: true,
              textColor: "greenDark",
            })
          : GetTypographyContent({
              content: license.content,
              size: "small",
            })}
      </React.Fragment>
    ))}
  </>
);
